module.exports = __webpack_public_path__ + "img/textil.a49ffe02.jpg";